import React from 'react';
import '../styles/contact.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function ContactMe() {
  const [contact, setContact] = React.useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleInputs = (e) => {
    const { name, value } = e.target;
    setContact((prevContact) => ({ ...prevContact, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, email, subject, message } = contact;

    const res = await fetch('https://portfolio-backend-sable-chi.vercel.app/', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name, email, subject, message }),
    });

    const data = await res.json();
    console.log(data);

    if (data.status ===400 || data.status === 500 || !data) {
      console.log('Contact entry failed');
      toast.error('Error!');
    } else if (data.status === 200 || data.status === 204 || data) {
      console.log('Contact entry successful');
      toast.success('Message Sent!');
    }
  };

  return (
    <div className="contact">
      <div className="contact-left">
        <h2 className="left-header">Let's Chat.</h2>
        <span>
          <h1>Tell me about your project</h1>
        </span>
        <h3>Let's Create something together 🖋</h3>

        <div className="reachout">
          <a
            href="https://www.linkedin.com/in/ojas-ketkar"
            target="_blank"
            rel="noreferrer"
            className="linkedin"
          > </a>
          <a
            href="mailto: ketkarojas@gmail.com"
            target="_blank"
            rel="noreferrer"
            className="mail"
          > </a>
          <a
            href="https://github.com/OjasKetkar"
            target="_blank"
            rel="noreferrer"
            className="github"
          > </a>
          <a
            href="https://medium.com/@ojasketkar"
            target="_blank"
            rel="noreferrer"
            className="medium"
          > </a>
        </div>
      </div>

      <div className="contact-right">
        <form action="POST" className="contact-form" onSubmit={handleSubmit}>
          <h1 className="contactform-header">Send Me A Message</h1>
          <input
            type="text"
            name="name"
            placeholder="*Full Name"
            value={contact.name}
            onChange={handleInputs}
          />
          <input
          type="text"
          name="email"
          placeholder="*Email"
          value={contact.email}
          onChange={handleInputs}
          className={contact.email.match(/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/) ? 'valid' : 'invalid'}
          />
          <input
            type="text"
            name="subject"
            placeholder="*Subject"
            value={contact.subject}
            onChange={handleInputs}
          />
          <textarea
            name="message"
            cols="30"
            rows="10"
            placeholder="Message"
            value={contact.message}
            onChange={handleInputs}
          />

          <button type="submit" className="submitBtn">
            Submit
          </button>
        </form>
      </div>

      <ToastContainer position="bottom-right" />
    </div>
  );
}
